import * as z from "zod";
import { FieldSchema, type ManifestValidationResult, validateManifest } from "./_shared.js";

export const MountManifestSchema = z.looseObject({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().optional(),
  entry: z.string().min(1),
  fields: z.array(FieldSchema).optional(),
  keywords: z.array(z.string()).optional(),
  license: z.string().optional(),
});

export type MountManifest = z.infer<typeof MountManifestSchema>;

export function validateMount(data: unknown): ManifestValidationResult<MountManifest> {
  return validateManifest(MountManifestSchema, data);
}
